import { useEffect, useState } from 'react';

import getFeatureFlags, { type FeatureFlagName } from 'helpers/getFeatureFlags';

export function useFeatureFlag(flag: FeatureFlagName) {
  const [featureFlag, setFeatureFlag] = useState<boolean | null>(null);

  useEffect(() => {
    const loadFeatureFlag = async () => {
      setFeatureFlag((await getFeatureFlags())[flag] ?? false);
    };

    void loadFeatureFlag();
  }, [flag]);

  return featureFlag;
}
